// color variables

const colors = {
  black: 'hsl(220, 20%, 20%)',
  lightGray: 'hsl(220, 20%, 70%)',
  blue: 'hsl(220, 80%, 60%)',
}

export default colors
